function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("title", null, "Full Screen");

var _ref2 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "expand",
  fill: "#3B3A42",
  fillRule: "nonzero"
}, React.createElement("path", {
  d: "M18,16.5857864 L18,13 L20,13 L20,20 L13,20 L13,18 L16.5857864,18 L12.2928932,13.7071068 L13.7071068,12.2928932 L18,16.5857864 Z M3.41421356,18 L7,18 L7,20 L0,20 L0,13 L2,13 L2,16.5857864 L6.29289322,12.2928932 L7.70710678,13.7071068 L3.41421356,18 Z M16.5857864,2 L13,2 L13,0 L20,0 L20,7 L18,7 L18,3.41421356 L13.7071068,7.70710678 L12.2928932,6.29289322 L16.5857864,2 Z M2,3.41421356 L2,7 L0,7 L0,0 L7,0 L7,2 L3.41421356,2 L7.70710678,6.29289322 L6.29289322,7.70710678 L2,3.41421356 Z",
  id: "Combined-Shape"
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    version: 1.1
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/full-scrren.2b9e9a51.svg";
export { SvgComponent as ReactComponent };